import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";
import { Button } from "../../ui/button";
import { ArrowLeft } from "lucide-react";

interface ReviewOfEstimatesForManagementBiasTailoringQuestionsProps {
  onBack?: () => void;
}

export default function ReviewOfEstimatesForManagementBiasTailoringQuestions({ onBack }: ReviewOfEstimatesForManagementBiasTailoringQuestionsProps) {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-white">Review of estimates for management bias - Tailoring Questions</h2>
          <p className="text-gray-400">Customize the audit program for Review of estimates for management bias</p>
        </div>
        {onBack && (
          <Button variant="outline" onClick={onBack}>
            <ArrowLeft className="h-4 w-4 mr-2" /> Back
          </Button>
        )}
      </div>

      <Card className="border-white/10 bg-black/40">
        <CardHeader>
          <CardTitle className="text-white">Tailoring Questions</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-white/70 text-sm">No tailoring questions defined yet.</div>
        </CardContent>
      </Card>
    </div>
  );
}
